/**
 * Formats a date string to a readable format (e.g., "January 15, 2024")
 * Returns 'Unknown' if the date is invalid or null
 */
export function formatDate(dateString: string | Date | null | undefined): string {
  if (!dateString) return 'Unknown';

  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'Unknown';

    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  } catch {
    return 'Unknown';
  }
}
